'use strict';

namespace Search {

    class DurationPicker {

        // Attr
        duration: number;
        select: () => void;
        show: boolean;

        private elements: any;

        private eventNamespace = 'durationpicker';
        private options: number[] = [3, 4, 7, 10, 14, 21];
        private html: JQuery;

        constructor (
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            private animationUtil: any
        ) {
            this.html = $('html');
        }

        init (elements): void {
            this.elements = elements;

            this.$scope.$watch('dp.show', (val) => {
                if (val != null) {
                    if (val) {
                        this.open();
                    } else {
                        this.close();
                    }
                }
            });

            // close if overlay is clicked
            this.elements.overlay.on('click.' + this.eventNamespace, (event) => {
                this.$scope.$apply(() => {
                    this.show = false;
                });
            });

            this.elements.durationPicker.on('click.' + this.eventNamespace, (event) => {
                event.stopPropagation();
            });

            this.$scope.$on('$destroy', () => {
                // unbind event listeners by namespace
                this.elements.overlay.off('.' + this.eventNamespace);
                this.elements.durationPicker.off('.' + this.eventNamespace);
                this.html.off('.' + this.eventNamespace);
            });

        }

        public selectDuration(duration: number) {
            // set the model
            this.duration = duration;
            this.$timeout(() => {
                // timeout allows model to update
                this.select();
            });
        }

        private open(): void {
            this.animationUtil.lockScroll();
            this.elements.overlay
                .addClass('fade-in')
                .removeClass('fade-out');

            this.html.on('keyup.' + this.eventNamespace, (event) => {
                // ESCAPE to close
                if (event.which === 27 && this.show) {
                    this.$scope.$apply(() => {
                        this.show = false;
                    });
                }
            });
        }

        private close(): void {
            this.elements.overlay
                .addClass('fade-out')
                .removeClass('fade-in');
            this.html.off('.' + this.eventNamespace);
        }

    }

    angular
        .module('search')
        .directive('durationPicker', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: DurationPicker,
                controllerAs: 'dp',
                bindToController: {
                    duration: '=',
                    select: '&',
                    show: '='
                },
                templateUrl: 'partials/search/durationpicker',
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller : DurationPicker
                ) => {
                    const elements = {
                        overlay: el,
                        durationPicker: el.find('.duration-picker')
                    };
                    controller.init(elements);
                }
            };
        });


}
